import { IConditionBookFilters } from "interfaces/ConditionBookPageState";

export const SET_CONDITION_BOOK_FILTERS =
  "CONDITION_BOOK_PAGE_SET_CONDITION_BOOK_FILTERS";
export const CLEAR_CONDITION_BOOK_FILTERS =
  "CONDITION_BOOK_PAGE_CLEAR_CONDITION_BOOK_FILTERS";
export const SET_SELECTED_FACILITY_ID =
  "CONDITION_BOOK_PAGE_SET_SELECTED_FACILITY_ID";
export const SET_SELECTED_RACE_ID = "CONDITION_BOOK_PAGE_SET_SELECTED_RACE_ID";

export interface IConditionBookPageAC {
  type:
    | typeof SET_CONDITION_BOOK_FILTERS
    | typeof CLEAR_CONDITION_BOOK_FILTERS
    | typeof SET_SELECTED_FACILITY_ID
    | typeof SET_SELECTED_RACE_ID;
  filters: IConditionBookFilters;
  selectedRaceId: string;
  selectedFacilityId: string;
}

export const setConditionBookFilters = (
  filters: IConditionBookFilters
): Partial<IConditionBookPageAC> => {
  return {
    type: SET_CONDITION_BOOK_FILTERS,
    filters
  };
};

export const clearConditionBookFilters = (): Partial<IConditionBookPageAC> => {
  return { type: CLEAR_CONDITION_BOOK_FILTERS };
};

export const setSelectedRaceId = (
  selectedRaceId: string
): Partial<IConditionBookPageAC> => {
  return { type: SET_SELECTED_RACE_ID, selectedRaceId };
};

export const setSelectedFacilityId = (
  selectedFacilityId: string
): Partial<IConditionBookPageAC> => {
  return { type: SET_SELECTED_FACILITY_ID, selectedFacilityId };
};
